module.exports = __webpack_public_path__ + "img/card02.f51e4b76.png";